document.addEventListener('click', function (e) {
  var q = e.target.closest('.faq-q');
  if (q) { q.parentElement.classList.toggle('open'); q.setAttribute('aria-expanded', q.parentElement.classList.contains('open')); }
});
document.querySelectorAll('[data-buy-box]').forEach(function (box) {
  var btns = box.querySelectorAll('.variant-btn');
  var input = box.querySelector('input[name="id"]');
  var priceEl = box.querySelector('.price');
  var compareEl = box.querySelector('.compare');
  var submit = box.querySelector('[type="submit"]');
  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      btns.forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      input.value = btn.dataset.id;
      if (priceEl) priceEl.textContent = btn.dataset.price;
      if (compareEl) {
        if (btn.dataset.compare && btn.dataset.compare !== btn.dataset.price) { compareEl.textContent = btn.dataset.compare; compareEl.style.display = ''; }
        else compareEl.style.display = 'none';
      }
      if (submit) { var avail = btn.dataset.available === 'true'; submit.disabled = !avail; submit.textContent = avail ? submit.dataset.label : 'Agotado'; }
    });
  });
});
